
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Phase1 from './components/Phase1';
import Phase2 from './components/Phase2';
import Phase3 from './components/Phase3';
import Phase4 from './components/Phase4';
import Phase5 from './components/Phase5';
import Phase6 from './components/Phase6';
import Phase7 from './components/Phase7';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Instructor from './components/Instructor';
import IsThisForMe from './components/IsThisForMe';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <Phase1 />
        <Phase2 />
        <Phase3 />
        <Phase4 />
        <Phase5 />
        <Phase6 />
        <Phase7 />
        <Pricing />
        <Testimonials />
        <Instructor />
        <IsThisForMe />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
